import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '='
    },
    template: `
        <loader-icon ng-if="vm.list.loading"></loader-icon>
        <table ng-if="!vm.list.loading && vm.list.items.length" class="data01">
            <thead>
                <tr>
                    <th>{{ 'course.Course' | translate }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr ng-if="!item.isArchived" ng-repeat="item in vm.list.items">
                    <td ng-if="vm.TokenService.isCompanyMagnum()">
                        <a ng-if="vm.canManageCourses" ui-sref="authorized.courses.courses.edit.version.list({ id: item.id })">{{ item.sop }} {{ item.activeI18n.name }}</a>
                        <span ng-if="!vm.canManageCourses">{{ item.sop }} {{ item.activeI18n.name }}</span>
                    </td>
                    <td ng-if="!vm.TokenService.isCompanyMagnum()">
                        <a ng-if="vm.canManageCourses" ui-sref="authorized.courses.courses.edit.version.list({ id: item.id })">{{ item.activeI18n.name }}</a>
                        <span ng-if="!vm.canManageCourses">{{ item.activeI18n.name }}</span>
                    </td>
                    <td class="actions">
                        <div class="action-menu" ng-click="$event.stopPropagation()">
                            <button
                                class="btn"
                                aria-haspopup="true"
                                aria-expanded="{{ !!vm.actions[item.id] }}"
                                ng-click="vm.openActionMenu($event, item.id)"
                                ><span>&nbsp;</span>
                            </button>
                            <ul role="menu" ng-if="vm.actions[item.id]" ng-click="$event.stopPropagation()">
                                <li ng-if="!vm.canManageCourses">
                                    <a
                                        ui-sref="authorized.courses.courses.edit.version.list({ id: item.id })"
                                        ui-sref-opts="{ location: 'replace' }">
                                        {{ 'general.View' | translate }}
                                    </a>
                                </li>
                                <li ng-if="vm.canManageCourses">
                                    <a
                                        ui-sref="authorized.courses.courses.edit.version.list({ id: item.id })"
                                        ui-sref-opts="{ location: 'replace' }">
                                    {{ 'general.Edit' | translate }}</a>
                                </li>
                                <li ng-if="vm.cloneAndArchiveButtonPrivileges(item)">
                                    <a
                                        ng-click="vm.archive(item)"
                                    >
                                        {{ 'general.Archive' | translate }}
                                    </a>
                                </li>
                                <li ng-if="vm.cloneAndArchiveButtonPrivileges(item)">
                                    <a
                                        ng-click="vm.clone(item.activeI18n)"
                                    >
                                        {{ 'general.Clone' | translate }}</a>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
                <tr ng-if="item.isArchived" class="status04" ng-repeat="item in vm.list.items">
                    <td ng-if="vm.TokenService.isCompanyMagnum()">
                        <a ng-if="vm.canManageCourses" ui-sref="authorized.courses.courses.edit.version.list({ id: item.id })">
                        {{ item.sop }} {{ item.activeI18n.name }} ({{ 'course.Archived' | translate }})</a>
                        <span ng-if="!vm.canManageCourses">{{ item.sop }} {{ item.activeI18n.name }} ({{ 'course.Archived' | translate }})</span>
                    </td>
                    <td ng-if="!vm.TokenService.isCompanyMagnum()">
                        <a ng-if="vm.canManageCourses" ui-sref="authorized.courses.courses.edit.version.list({ id: item.id })">{{ item.activeI18n.name }} ({{ 'course.Archived' | translate }})</a>
                        <span ng-if="!vm.canManageCourses">{{ item.activeI18n.name }} ({{ 'course.Archived' | translate }})</span>
                    </td>
                    <td class="actions" >
                        <div class="action-menu" ng-click="$event.stopPropagation()">
                            <button
                                class="btn"
                                aria-haspopup="true"
                                aria-expanded="{{ !!vm.actions[item.id] }}"
                                ng-click="vm.openActionMenu($event, item.id)"
                                ><span>&nbsp;</span>
                            </button>
                            <ul role="menu" ng-if="vm.actions[item.id]" ng-click="$event.stopPropagation()">
                                 <li>
                                    <a ui-sref="authorized.courses.courses.edit.version.list({ id: item.id })">
                                        <span ng-if="vm.canManageCourses">{{ 'general.Edit' | translate }}</span>
                                        <span ng-if="!vm.canManageCourses">{{ 'general.View' | translate }}</span>
                                    </a>
                                 </li>
                            </ul>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    `
})
export default class {
    constructor ($translate, PrivilegeService, TokenService, ModalService, toastr, $state, Upload, CourseService,
                 FormFactory, $rootScope, ResponseService, lodash, CourseResource, COURSE_SITE_ACCESS_ENUM, $document, $timeout) {
        this.canManageCourses = PrivilegeService.canManageCourses();
        this.canAdministrateCourses = PrivilegeService.isCourseAdmin();
        this.CourseService = CourseService;
        this.TokenService = TokenService;
        this.actions = [];
        this.translate = $translate;
        this.$toastr = toastr;
        this.ModalService = ModalService;
        this.$state = $state;
        this.Upload = Upload;
        this.FormFactory = FormFactory;
        this.ResponseService = ResponseService;
        this.CourseResource = CourseResource;
        this.COURSE_SITE_ACCESS_ENUM = COURSE_SITE_ACCESS_ENUM;
        this.rootScope = $rootScope;
        this.lodash = lodash;
        this.form = {};
        this.$timeout = $timeout;
        this.$document = $document;
        this.$document.on('click', () => {
            // Only close menus if there are any open
            if (this.actions.length > 0) {
                // Use $timeout to ensure immediate UI update
                this.$timeout(() => {
                    this.closeAllMenus();
                }, 0);
            }
        });
    }

    openActionMenu ($event, rowId) {
        $event.stopPropagation();
        $event.preventDefault();

        // First close all menus, then toggle the clicked one
        this.$timeout(() => {
            // If this menu is already open, just close it
            if (this.actions[rowId]) {
                this.actions = [];
            }
            else {
                // Close all menus and open only this one
                this.actions = [];
                this.actions[rowId] = true;
            }
        }, 0);
    }
    closeAllMenus () {
        // Use $timeout for immediate UI update
        this.$timeout(() => {
            this.actions = [];
        }, 0);
    }
    clone (courseI18n) {
        this.closeAllMenus();
        return this.ModalService.open({
            template: `
                <modals-courses-cloned
                    uib-modal-instance="vm.$uibModalInstance"
                    course="vm.course"
                    class="wrapper"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.course = courseI18n;
            }
        });
    }
    archive (course) {
        this.closeAllMenus();
        const confirmMessages = [];
        const message = this.translate.instant(
            'course.On archiving the course, all ongoing enrollments will be cancelled and course can longer be planned' +
            ' nor enrolled in. Are you sure you wish to archive the course?'
        );
        confirmMessages.push(message);
        this.ModalService.confirm(confirmMessages, 'medium')
            .then(() => {
                const params = {
                    id: course.id,
                    pageSize: 0,
                    expand: 'courseI18ns,fields,sites'
                };
                this.CourseResource.getCourse(params).$promise
                    .then((fullCourse) => {
                        fullCourse.isArchived = !fullCourse.isArchived;
                        fullCourse.fields = fullCourse.fields.map((field) => (field.id));
                        fullCourse.expirationMonths = fullCourse.expirationMonths ? fullCourse.expirationMonths : 0;

                        if (fullCourse.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
                            fullCourse.courseSiteIds = [];
                        }
                        else {
                            fullCourse.courseSiteIds = fullCourse.sites.map(site => site.id);
                        }
                        return this.CourseResource.update({ id: fullCourse.id }, fullCourse).$promise;
                    })
                    .then(() => {
                        this.list.items = this.list.items.filter((item) => item.id !== course.id);
                        this.$toastr.success(
                            this.translate.instant('course.Course successfully archived')
                        );
                    })
                    .catch(() => {
                        this.$toastr.error(
                            this.translate.instant('course.Failed to update course status')
                        );
                    });
            });
    }

    cloneAndArchiveButtonPrivileges (course) {
        return this.CourseService.canManageCourse(course);
    }

    $onDestroy () {
        // Clean up document click handler when component is destroyed
        if (this.$document) {
            this.$document.off('click');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/list/list/index.js